module.exports = __webpack_public_path__ + "assets/5fb6db8e63d68be745b503036a374c11.mp3";